import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

// const url = 'http://localhost:8072';
const url = createUrl('report');

export class S3 extends Api {
    constructor(http, config = {}) {
        super(http, url, 's3', config);
    }
}

